import { render, staticRenderFns } from "./UserLogsTab.vue?vue&type=template&id=437afcc9&"
import script from "./UserLogsTab.vue?vue&type=script&lang=ts&"
export * from "./UserLogsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports